import { Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { BaseComponent } from './dashboard/base.component';
import { RinnoviComponent } from './dashboard/rinnovi.component';
import { PagamentiComponent } from './dashboard/pagamenti.component';
import { MygroupComponent } from './dashboard/my-group/mygroup.component';
import { AddSocioGroupComponent } from './dashboard/my-group/add-socio-group.component';
import { BaseGroupComponent } from './dashboard/my-group/base-group.component';
import { AddAmicoFedeleComponent } from './dashboard/my-group/add-amico-fedele.component';
import { AssocNazioniResolver } from './shared/assocnazioni.resolver';
import { ModifySocioComponent } from './dashboard/my-group/modify-socio.component';
import { ModifySocioResolver } from './dashboard/my-group/modify-socio.resolver';
import { PagamentoRinnovoComponent } from './nuovo-pagamento/pagamento-rinnovo.component';
import { ModifyAmicoFedeleComponent } from './dashboard/my-group/modify-amico-fedele.component';
import { ModifyAmicoFedeleResolver } from './dashboard/my-group/modify-amico-fedele.resolver';
import { PublicUserRegisterComponent } from './public/public-user-register.component';
import { OidcGuardService } from "./auth/auth.guard";

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'nuovoutente', 
    pathMatch: 'full'
  },
  {
    path: 'nuovoutente',
    component: PublicUserRegisterComponent,
    resolve: {
      data: AssocNazioniResolver
    }
  },
  {
    path: 'area-utente',
    component: BaseComponent,
    canActivate: [OidcGuardService],
    children: [
      { path: '', redirectTo: 'miei-dati', pathMatch: 'full' },
      {
        path: 'miei-dati',
        component: DashboardComponent,
        resolve: {
          dataDash: AssocNazioniResolver
        }
      },
      {
        path: 'pagamento',
        component: PagamentoRinnovoComponent
      },
      { path: 'rinnovi', component: RinnoviComponent },
      { path: 'pagamenti', component: PagamentiComponent },
      {
        path: 'gruppo', component: BaseGroupComponent, children: [
          { path: '', component: MygroupComponent },
          {
            path: 'modifica/:id',
            component: ModifySocioComponent,
            resolve: {
              data: AssocNazioniResolver,
              dataSocio: ModifySocioResolver,
            }
          },
          {
            path: 'aggiungi',
            component: AddSocioGroupComponent,
            resolve: {
              data: AssocNazioniResolver
            }
          },
          { path: 'aggiungi-amico-fedele', component: AddAmicoFedeleComponent },
          {
            path: 'modifica-amico-fedele/:id',
            component: ModifyAmicoFedeleComponent,
            resolve: {
              dataAmicoFedele: ModifyAmicoFedeleResolver,
            }
          }
        ]
      }
    ]
  },
  { path: '**', redirectTo: 'area-utente' }
]


